import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-collapse",
  "use": "arrow-collapse-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"arrow-collapse\"><path fill=\"currentColor\" d=\"M4.68 11h16v2h-16v-2Zm12-5-4 4-4-4h3V2h2v4h3Zm-8 12 4-4 4 4h-3v4h-2v-4h-3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol